import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
// import { LayoutModule } from "../../layouts/layout.module";
import { RouterModule } from '@angular/router';
import { SharedModule } from "../../../freightconfirmation/app.sharemodule";
import { DefaultComponent } from "./default.component";
import { AsideNavSharedModule } from "../../layouts/aside-nav/aside-nav_shared.module";
import { ChartModule } from 'primeng/chart';
import { ProgressBarModule } from 'primeng/progressbar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ProgressbarModule } from 'ngx-bootstrap';
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

@NgModule({
    imports: [
        CommonModule,
        // LayoutModule,
        SharedModule,
        ChartModule,
        HttpClientModule,
        ProgressBarModule,
        ScrollPanelModule,
        AsideNavSharedModule,
        RouterModule,
        ProgressbarModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
    ],
    exports: [DefaultComponent],
    declarations: [DefaultComponent]
})
export class DefaultSharedModule { }
